import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';
import { SUPPORTED_LANGS } from '@app/app.routes';

export const langGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const translate = inject(TranslateService);
  const doc = inject(DOCUMENT);
  const lang = route.paramMap.get('lang') as string;

  if (!SUPPORTED_LANGS.includes(lang as typeof SUPPORTED_LANGS[number])) {
    return router.createUrlTree(['/fr']);
  }

  // Aussi côté serveur : `<html lang>` fait partie du HTML initial vu par les robots.
  doc.documentElement.lang = lang;
  // Les <link rel="alternate" hreflang> sont posés par SeoService (URL absolues, rendu serveur, pages
  // d'interface uniquement) : ne jamais les injecter ici, ils s'appliqueraient aussi aux chants.

  return translate.use(lang).pipe(map(() => true));
};
